export default "__VITE_ASSET__BAzIqCUN__"